// 判断客户端类型
function terminalType() {
  return /(airclass|homework|homework_knowledge|parent|haokezaixian|miaobao|iot_app|youketang|MicroMessenger|WeiBo|QQ(?=[/_]))/i.test(
    navigator.userAgent
  )
    ? RegExp.$1.toLowerCase()
    : 'other'
}
export default terminalType
